import React, { createContext, useContext, useState } from 'react';

type AccordionContextValue = {
    openId: string | null;
    setOpenId: (id: string | null) => void;
};

const AccordionContext = createContext<AccordionContextValue | null>(null);

type Props = { children: React.ReactNode; defaultOpenId?: string | null };

export function Accordion({ children, defaultOpenId = null }: Props) {
    const [openId, setOpenId] = useState<string | null>(defaultOpenId);
    return (
        <AccordionContext.Provider value={{ openId, setOpenId }}>
            {children}
        </AccordionContext.Provider>
    );
}

export function useAccordion() {
    return useContext(AccordionContext);
}


